import { ComponentClassNames } from '../../util/classNames';
import { memoizeFunction, mergeStyleSets } from '../../util/styling';

type GetClassNames = (disableNativePageScroll: boolean) => ComponentClassNames<'appLayout'>;

export const getClassNames: GetClassNames = memoizeFunction((disableNativePageScroll) =>
  mergeStyleSets({
    appLayout: {
      ':global(body)': disableNativePageScroll ? { height: '100%', overflow: 'hidden' } : {},
    },
  })
);
